import React, { useEffect } from "react";
import useList from "react-use/lib/useList";
import { gql } from "apollo-boost";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import { List, Table, Tag } from "antd";
import formatDate from "date-fns/format";
import get from "lodash/fp/get";

const ADMIN_LOGS_QUERY = gql`
  query latestLogList {
    latestLogList {
      serial
      type
      payload
      insertedAt
    }
  }
`;

const ADMIN_LOGS_SUBSCRIPTION = gql`
  subscription onLogAdded {
    logAdded {
      serial
      type
      payload
      insertedAt
    }
  }
`;

export const Data = ({ children }) => {
  const query = useQuery(ADMIN_LOGS_QUERY);

  const [addedLogs, { insertAt: insertAddedLogAt }] = useList();
  const sub = useSubscription(ADMIN_LOGS_SUBSCRIPTION);
  const subSerial = get("data.logAdded.serial", sub);
  useEffect(() => {
    if (!sub.data || !sub.data.logAdded) return;
    insertAddedLogAt(0, sub.data.logAdded);
  }, [subSerial, insertAddedLogAt, sub.data]);

  if (!query.data) {
    return children(null);
  }

  const { latestLogList } = query.data;
  const rows = [...addedLogs, ...latestLogList];

  return children({ rows });
};

export const View = ({ rows }) => {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const columns = [
    {
      title: "Serial",
      dataIndex: "serial",
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Inserted at",
      dataIndex: "insertedAt",
      render: (dateTime) =>
        formatDate(new Date(`${dateTime}Z`), "yyyy-MM-dd HH:mm", { timeZone }),
    },
    {
      title: "Data",
      dataIndex: "payload",
      render: (payload) => {
        let parsedPayload;
        try {
          parsedPayload = JSON.parse(payload);
        } catch (e) {
          return null;
        }

        const data = Object.entries(parsedPayload)
          .map(([key, value]) => {
            try {
              switch (key) {
                case "license":
                  return (
                    <span>
                      <strong>License:</strong> {value.name}
                    </span>
                  );
                case "scenario":
                  return (
                    <span>
                      <strong>Scenario:</strong> {value.name}
                    </span>
                  );
                case "session":
                  return (
                    <span>
                      <strong>Session:</strong> {value.pin}
                    </span>
                  );
                case "user":
                  return (
                    <span>
                      <strong>User: </strong> {value.username}{" "}
                      {value.is_admin && <Tag color="volcano">admin</Tag>}
                    </span>
                  );
                default:
                  return null;
              }
            } catch (e) {
              return null;
            }
          })
          .filter((x) => x);

        return (
          data.length > 0 && (
            <List
              size="small"
              dataSource={data}
              renderItem={(item) => <List.Item>{item}</List.Item>}
            />
          )
        );
      },
    },
  ];

  return (
    <Table
      rowKey={(row) => `${row.serial}:${row.insertedAt}`}
      dataSource={rows}
      columns={columns}
      pagination={false}
    />
  );
};
